import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useDemo } from '../contexts/DemoContext';

import { Button } from '@/components/ui/Button';
import { ROUTE_PATHS } from '@/config/constants';
import { useAuth } from '@/contexts/AuthContext';

export function Header() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Demo.components.Header',
  });

  const { user } = useAuth();

  const { setPage } = useDemo();
  const navigate = useNavigate();

  function handleExit() {
    navigate(ROUTE_PATHS.HOME);
  }

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
        <button
          className="flex items-center gap-2"
          onClick={() => setPage('home')}
        >
          <div className="text-xl font-medium text-foreground">
            {user?.customer.name}
          </div>
        </button>

        <nav className="hidden items-center gap-6 md:flex">
          <button
            className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            onClick={() => setPage('home')}
          >
            {t('home')}
          </button>

          <button
            className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            onClick={() => setPage('catalog')}
          >
            {t('catalog')}
          </button>
        </nav>

        <Button size="sm" onClick={handleExit}>
          {t('exit')}
        </Button>
      </div>
    </header>
  );
}
